// utils/TvRuntimeContext.js
import { createContext, useContext } from "react";

const TvRuntimeContext = createContext({ tvId: null });

export function TvRuntimeProvider({ tvId = null, children }) {
  return (
    <TvRuntimeContext.Provider value={{ tvId }}>
      {children}
    </TvRuntimeContext.Provider>
  );
}

export function useTvRuntime() {
  return useContext(TvRuntimeContext);
}
